
export const salesOptions = [
    {
      label1: "Advantage+ shopping campaign",
      label2: "Maximise performance and reach valuable audiences with a simplified setup. Preset settings include placements, age and more.",
      value: "AUTOMATED_SHOPPING_ADS"
    },
    {
      label1: "Manual sales campaign",
      label2: "Create a sales campaign from scratch using the standard setup.",
      value: "MANUAL_SALES"
    }
  ];
  
  export const budgetOptions = [
    {
      label: "Daily budget",
      value: "daily_budget"
    },
    {
      label: "Lifetime budget",
      value: "lifetime_budget"
    }
  ];
  
  export const bidStrategiesForLeads = [
    {
      label: 'Highest volume',
      description: 'Get the most results for your budget.',
      value: 'LOWEST_COST_WITHOUT_CAP',
    },
    {
      label: 'Cost per result goal',
      description: 'Aim for a certain cost per result while maximising the volume of results.',
      value: 'COST_CAP',
    },
    {
      label: 'Bid cap',
      description: 'Set the highest that you want to bid in any auction.',
      value: 'LOWEST_COST_WITH_BID_CAP',
    },
  ];
  
  export const bidStrategiesForSales = [
    {
      label: 'Highest volume or value',
      description: 'Get the most results or purchase value for your budget.',
      value: 'LOWEST_COST_WITHOUT_CAP',
    },
    {
      label: 'Cost per result goal',
      description: 'Aim for a certain cost per result while maximising the volume of results.',
      value: 'COST_CAP',
    },
    {
      label: 'ROAS goal',
      description: 'Aim for a certain return on ad spend while maximising the value of results.',
      value: 'LOWEST_COST_WITH_MIN_ROAS',
    },
    {
      label: 'Bid cap',
      description: 'Set the highest that you want to bid in any auction.',
      value: 'LOWEST_COST_WITH_BID_CAP',
    },
  ];
  